import ModalPublicationConfigurationFTP from "./ModalPublicationConfigurationFTP"
import { useEffect, useState } from "react"
import BackOfficeAPIClient from "../../clients/BackofficeAPIClient"
import { ModalDeletePublicationConfigurationFTP } from "./ModalDeletePublicationConfigurationFTP"
import { IConfigurationPublicationFTP } from "./PublicationConfigurationFTP.types"



export default function PublicationConfigurationFTP() {
    const [ configs, setConfigs ] = useState<IConfigurationPublicationFTP[]>([])
    const [ selectedConfig, setSelectedConfig ] = useState<IConfigurationPublicationFTP | null>(null)
    const [ configToDelete, setConfigToDelete ] = useState<IConfigurationPublicationFTP | null>(null)
    const backofficeApiClient = new BackOfficeAPIClient()

    const fetchConfigs = async () => {
        try {
            const configs = await backofficeApiClient.get<IConfigurationPublicationFTP[]>("/configurationPublicationFTP")
            setConfigs(configs)
        } catch (e) {
            console.error("Erreur lors de la récupération des configurations FTP", e)
        }
    }

    const requestCreateConfig = async (config: Omit<IConfigurationPublicationFTP, "IDConfigPublicationFTP">) => {
        try {
            await backofficeApiClient.post("/configurationPublicationFTP", config)
            await fetchConfigs()
        } catch (e) {
            console.error("Erreur lors de la création de la config " + config.Host, e)
        }
    }

    const requestUpdateConfig = async (config: IConfigurationPublicationFTP) => {
        try {
            await backofficeApiClient.put(`/configurationPublicationFTP/${config.IDConfigPublicationFTP}`, config)
            await fetchConfigs()
        } catch (e) {
            console.error("Erreur lors de l'update de la config " + config.Host, e)
        }
    }

    const requestDeleteConfig = async (id?: number) => {
        try {
            if (!id) {
                throw new Error()
            }
            await backofficeApiClient.delete(`/configurationPublicationFTP/${id}`, {})
            await fetchConfigs()
        } catch (e) {
            console.error("Erreur lors de la suppression de la config " + id, e)
        }
    }

    const updateConfig = (updatedConfig: IConfigurationPublicationFTP) => {
        setConfigs(prevConfigs =>
            prevConfigs.map(config =>
                config.IDConfigPublicationFTP === updatedConfig.IDConfigPublicationFTP ? updatedConfig : config,
            ),
        )
        requestUpdateConfig(updatedConfig)
    }

    useEffect(() => {
        fetchConfigs()
    }, [])

    return (
        <div className={"container-fluid d-flex flex-column"} style={{ gap: "10px" }}>
            <div className="d-flex flex-row justify-content-between">
                <h2>Configuration FTP</h2>
                <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalPublicationConfiguration">Créer une configuration</button>
            </div>
            <div className="d-flex flex-row flex-wrap" style={{ gap: "20px" }}>
                {configs.map((config, index) => (
                    <div key={index} className="card shadow-sm" style={{ width: '18rem' }}>
                        <div className="card-body">
                            <h5 className="card-title">{config.Host}</h5>
                            <p className="card-text">Login : {config.Login}</p>
                            <div className="d-flex flex-row" style={{gap: "10px"}}>
                                <button type="button" data-toggle="modal" data-target="#modalPublicationConfiguration"
                                        className="btn btn-primary btn-sm" onClick={() => setSelectedConfig(config)}>Modifier
                                </button>
                                <button type="button" className="btn btn-danger btn-sm"
                                        onClick={() => setConfigToDelete(config)}
                                        data-toggle="modal" data-target="#modalDeleteConfigPublication"
                                >
                                    Supprimer
                                </button>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
            <ModalPublicationConfigurationFTP updateConfig={updateConfig} updatingConfig={selectedConfig} createConfig={requestCreateConfig}/>
            <ModalDeletePublicationConfigurationFTP configToDelete={configToDelete} requestDeleteConfig={requestDeleteConfig} />
        </div>
    )
}
